export default {
  AU: [
    'AU-ACT',
    'AU-NSW',
    'AU-NT',
    'AU-QLD',
    'AU-SA',
    'AU-TAS',
    'AU-VIC',
    'AU-WA'
  ],
  CA: [
    'CA-AB',
    'CA-BC',
    'CA-MB',
    'CA-NB',
    'CA-NL',
    'CA-NS',
    'CA-NT',
    'CA-NU',
    'CA-ON',
    'CA-PE',
    'CA-QC',
    'CA-SK',
    'CA-YT'
  ],
  US: [
    'US-AK',
    'US-AL',
    'US-AR',
    'US-AZ',
    'US-CA',
    'US-CO',
    'US-CT',
    'US-DC',
    'US-DE',
    'US-FL',
    'US-GA',
    'US-HI',
    'US-IA',
    'US-ID',
    'US-IL',
    'US-IN',
    'US-KS',
    'US-KY',
    'US-LA',
    'US-MA',
    'US-MD',
    'US-ME',
    'US-MI',
    'US-MN',
    'US-MO',
    'US-MS',
    'US-MT',
    'US-NC',
    'US-ND',
    'US-NE',
    'US-NH',
    'US-NJ',
    'US-NM',
    'US-NV',
    'US-NY',
    'US-OH',
    'US-OK',
    'US-OR',
    'US-PA',
    'US-RI',
    'US-SC',
    'US-SD',
    'US-TN',
    'US-TX',
    'US-UT',
    'US-VA',
    'US-VT',
    'US-WA',
    'US-WI',
    'US-WV',
    'US-WY'
  ],
  BR: [
    'BR-AC',
    'BR-AL',
    'BR-AM',
    'BR-AP',
    'BR-BA',
    'BR-CE',
    'BR-DF',
    'BR-ES',
    'BR-GO',
    'BR-MA',
    'BR-MG',
    'BR-MS',
    'BR-MT',
    'BR-PA',
    'BR-PB',
    'BR-PE',
    'BR-PI',
    'BR-PR',
    'BR-RJ',
    'BR-RN',
    'BR-RO',
    'BR-RR',
    'BR-RS',
    'BR-SC',
    'BR-SE',
    'BR-SP',
    'BR-TO'
  ]
}
